const STORAGE_KEY = 'first_touch_referral';

interface ReferralData {
  referrer: string;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
}

function stripProtocolAndWww(url: string): string {
  return url
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .split('/')[0];
}

function parseReferralData(): ReferralData {
  const referrer = document.referrer
    ? stripProtocolAndWww(document.referrer)
    : '';

  const params = new URLSearchParams(window.location.search);

  return {
    referrer,
    utmSource: params.get('utm_source') || '',
    utmMedium: params.get('utm_medium') || '',
    utmCampaign: params.get('utm_campaign') || '',
  };
}

function formatReferralString(data: ReferralData, maxLength: number): string {
  const parts: string[] = [];

  const ref = data.referrer || 'direct';
  parts.push(ref);

  const utmParts: string[] = [];
  if (data.utmSource) utmParts.push(`src:${data.utmSource}`);
  if (data.utmMedium) utmParts.push(`med:${data.utmMedium}`);
  if (data.utmCampaign) utmParts.push(`camp:${data.utmCampaign}`);

  if (utmParts.length > 0) {
    parts.push(utmParts.join(' '));
  }

  let result = parts.join(' | ');

  if (result.length > maxLength) {
    if (data.utmCampaign) {
      const withoutCampaign = [ref];
      const shortUtm: string[] = [];
      if (data.utmSource) shortUtm.push(`src:${data.utmSource}`);
      if (data.utmMedium) shortUtm.push(`med:${data.utmMedium}`);
      if (shortUtm.length > 0) withoutCampaign.push(shortUtm.join(' '));
      result = withoutCampaign.join(' | ');
    }

    if (result.length > maxLength && data.utmMedium) {
      const withoutMedium = [ref];
      if (data.utmSource) withoutMedium.push(`src:${data.utmSource}`);
      result = withoutMedium.join(' | ');
    }

    if (result.length > maxLength) {
      result = ref;
    }

    if (result.length > maxLength) {
      result = result.substring(0, maxLength);
    }
  }

  return result;
}

export function captureReferralSource(): void {
  if (typeof window === 'undefined') return;

  const existing = sessionStorage.getItem(STORAGE_KEY);
  if (existing) return;

  const data = parseReferralData();

  if (!data.referrer && !data.utmSource && !data.utmMedium && !data.utmCampaign) {
    sessionStorage.setItem(STORAGE_KEY, 'direct');
    return;
  }

  const formatted = formatReferralString(data, 150);
  sessionStorage.setItem(STORAGE_KEY, formatted);
}

export function getReferralSource(): string | null {
  if (typeof window === 'undefined') return null;
  return sessionStorage.getItem(STORAGE_KEY);
}
